// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { get } from './api';
import { ENDPOINTS } from '../utils/constants';
import type { PlanFile } from '../types';

/**
 * Download and parse the plan JSON file via the BFF proxy.
 * `siteId` is the plan's site (HITL's `approval.siteId`), not parsed from the key;
 * the BFF checks the caller's access to it and that the key is that site's own.
 */
export const fetchPlanFile = async (siteId: string, storeKey: string): Promise<PlanFile> => {
  return get<PlanFile>(ENDPOINTS.OBJECT_STORE_SITE_DOWNLOAD(siteId, storeKey));
};
